//# sourceMappingURL=middleware.mjs.map
/// <reference types="./middleware.d.mts" />
import * as $client from "../../auth0_client/auth0/client.mjs";
import * as $auth0 from "../../auth0_client/auth0/client/user.mjs";
import * as $promise from "../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../gleam_stdlib/gleam/option.mjs";
import * as $function from "../../tiamat/tiamat/function.mjs";
import * as $store from "../data/store.mjs";
import { Ok } from "../gleam.mjs";

export function require_access_token(client, next) {
  let token = $client.get_token_silently(client);
  return $promise.await$(
    token,
    (access_token) => {
      if (access_token instanceof Ok) {
        let token$1 = access_token[0];
        let _pipe = next(token$1);
        return $promise.map(_pipe, $function.constant(undefined));
      } else {
        return $promise.resolve(undefined);
      }
    },
  );
}

export function require_org_id(store, next) {
  let $ = $option.then$(store.user, $auth0.org_id);
  if ($ instanceof Some) {
    let org_id = $[0];
    let _pipe = next(org_id);
    return $promise.map(_pipe, $function.constant(undefined));
  } else {
    return $promise.resolve(undefined);
  }
}

export function require_user_id(store, next) {
  let $ = $option.map(store.user, $auth0.id);
  if ($ instanceof Some) {
    let user_id = $[0];
    let _pipe = next(user_id);
    return $promise.map(_pipe, $function.constant(undefined));
  } else {
    return $promise.resolve(undefined);
  }
}
